
import { ActionMenuItem, BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import i18n from "../../services/localization-service/i18n";
import { AddFormDataIcon } from "../action-menu/ActionMenuIcons";
import { getActionMenuItems } from "../action-menu/BaseActions";

export enum CustomFormListActionEnum  {
    AddFormData = 'addformdata'
}

const actionEnums = [
    BaseActionEnum.Export,
    BaseActionEnum.Refresh,
    BaseActionEnum.Favorite
];

const actions = [{
    id: 'addformdata',
    label: i18n.t("forms.addData"),
    icon: AddFormDataIcon,
    action: CustomFormListActionEnum.AddFormData,
    order: 0
}, ...getActionMenuItems(actionEnums)];



export const actionItems = actions.map((item) => {
  if (item.action === BaseActionEnum.Export) {
    return {
      ...item,
      subActions: item.subActions?.filter(o => o.action === BaseActionEnum.Excel)
    };
  }
  return item;
}) as ActionMenuItem[];        
